import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { approveOrder } from '../orders'

export default function useApproveOrder() {
  const queryClient = useQueryClient()

  const { mutate, data, reset, isLoading } = useMutation(approveOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries('opportunities')
      notification.success({
        message: 'Sucesso!',
        description: 'Aprovado com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível aprovar!'
      })
    }
  })

  return { mutate, data, reset, isLoading }
}
